
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/platform",
      function () {
        return require("private-next-pages/en/platform/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/platform"])
      });
    }
  